var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3014 21.8894L24.9514 2.38241C24.42 1.87253 23.58 1.87253 23.0487 2.38241L2.67848 21.9095C2.24741 22.3405 2 22.9344 2 23.5413C2 24.8046 3.02859 25.8331 4.29178 25.8331H7.5V42.3335C7.5 44.3591 9.14089 46 11.1668 46H36.8332C38.8591 46 40.5 44.3592 40.5 42.3335V25.8331H43.7082C44.9715 25.8331 46 24.8045 46 23.5413C46 22.9344 45.7526 22.3405 45.3014 21.8894Z",
    fill: "#CEE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2617 38.596C22.0282 37.575 20.8803 36.4548 19.8293 35.2467C17.9777 33.1067 16 30.114 16 27C16 22.5817 19.5817 19 24 19C28.4183 19 32 22.5817 32 27C32 30.114 30.0223 33.1067 28.1707 35.2467C27.1197 36.4548 25.9718 37.575 24.7383 38.596C24.5317 38.7657 24.3103 38.9877 24.0283 38.9993C24.0189 38.9998 24.0094 39 24 39C23.705 39 23.4757 38.7717 23.2617 38.596ZM24 24.3333C23.2044 24.3333 22.4413 24.6494 21.8787 25.212C21.3161 25.7746 21 26.5377 21 27.3333C21 28.129 21.3161 28.892 21.8787 29.4547C22.4413 30.0173 23.2044 30.3333 24 30.3333C24.7956 30.3333 25.5587 30.0173 26.1213 29.4547C26.6839 28.892 27 28.129 27 27.3333C27 26.5377 26.6839 25.7746 26.1213 25.212C25.5587 24.6494 24.7956 24.3333 24 24.3333Z",
    fill: "#3269F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.ccafe7cb04789cbd10b200c6d7aacefd.svg";
export { ForwardRef as ReactComponent };